import * as React from 'react'
import Svg from '../Svg'
export const SvgPressure = (props: React.SVGProps<SVGSVGElement>) => (
    <Svg
        id="pressure_svg__Layer_1"
        x={0}
        y={0}
        viewBox="0 0 100 100"
        xmlSpace="preserve"
        fill="#000"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        {...props}
    >
        <style>{'.pressure_svg__st0{fill:#010101}'}</style>
        <path
            className="pressure_svg__st0"
            d="M72.9 69.2c4.5-5.4 7-12.2 7-19.2 0-16.5-13.4-29.9-29.9-29.9S20.1 33.5 20.1 50c0 7 2.5 13.8 7 19.2l1.4 1.7-5.9 4.9 1.7 2 5.9-4.9-1.6-2-3.3 2.8-1.5-1.7c-4.4-5.2-7.1-11.6-7.8-18.3l-3.3.2-.2-2.6 3.3-.2V50c0-8.8 3.3-16.8 8.7-22.8l-2.4-2.3 1.8-1.8 2.4 2.3c5.9-5.6 13.7-9.2 22.4-9.5v-3.4h2.6v3.4c8.7.3 16.6 3.9 22.4 9.5l2.4-2.3 1.8 1.8-2.4 2.3c5.4 6.1 8.7 14.1 8.7 22.8v1.1l3.3.2-.2 2.6-3.3-.2c-.7 6.7-3.4 13.1-7.8 18.3l-1.4 1.7 2.6 2.1-1.6 2-5.9-4.9 1.6-2 1.4-1.7z"
        />
        <path
            className="pressure_svg__st0"
            d="M40.1 56l3.5 3.7 4.5-4.9c.7.3 1.5.4 2.3.4 2.8-.2 5-2.6 4.8-5.4 0-.7-.2-1.4-.6-2l13.6-15-15.6 13c-.8-.5-1.8-.7-2.9-.7-2.8.2-5 2.6-4.8 5.4 0 .5.1.9.3 1.4L40.1 56z"
        />
        <path
            className="pressure_svg__st0"
            d="M50 7.7c23.4 0 42.3 19 42.3 42.3S73.4 92.3 50 92.3 7.7 73.4 7.7 50 26.6 7.7 50 7.7zM50 0C22.4 0 0 22.4 0 50s22.4 50 50 50 50-22.4 50-50S77.6 0 50 0z"
        />
    </Svg>
)
SvgPressure.isIcon = true
export default SvgPressure
